__turbopack_context__.v({
  "chip-position": "chips-overlay-module-scss-module__zUiSPW__chip-position",
  "chips-overlay": "chips-overlay-module-scss-module__zUiSPW__chips-overlay",
});
